import GaEvent from './GaEvent';

export default class ContentViewedGaEvent extends GaEvent {
  static NAME = 'content_viewed';

  constructor() {
    super(ContentViewedGaEvent.NAME);
  }
}
